import type { Breakpoint } from '@mui/material';
import { useLaptopLayoutAndUp } from '../../../utils';

export const usePaperWidth = (maxWidth?: false | Breakpoint) => {
  const laptopLayout = useLaptopLayoutAndUp();
  const fullWidth = laptopLayout ? '80%' : '100%';
  return { sx: { maxWidth: maxWidth || fullWidth } };
};
